import storage from 'util/storage'
import { createBasicSelector } from 'util/redux'

export const selectIsImpersonating = createBasicSelector(() =>
  storage.get('impersonating')
)
